import axios from 'axios';
import api from './ApiService';

export interface InstitutionalResponse {
  texts: Text[];
  banners: Banner[];
  videos: Video[];
}

// export interface Institutional {
//   texts: Text[];
// }

export interface Text {
    id: number;
    page_id: number;
    name: string;
    description: string;
    group?: string;
    text: string;
}

export interface Banner {
  id: number;
  page_id: number;
  name: string;
  description: string;
  banner_path: string;
  recommended_width?: number;
  recommended_height?: number;
  url?: string;
}

export interface Video {
  id: number;
  page_id: number;
  name: string;
  description: string;
  video_path: string;
  url?: string;
}

export async function getText(id: number, institutional: InstitutionalResponse) {
  return (
    institutional?.texts?.find((e : Text) => e.id == id)?.text
  )
}

export async function home(): Promise<InstitutionalResponse> {
  return getInstitutional(3);
}

export async function getInstitutional(page_id: number): Promise<InstitutionalResponse> {
  try {
    const response = await api.get('/institutional/get/' + page_id);
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar a página', error);
    throw new Error('Erro ao carregar a página');
  }
}

export async function getSocialMedia(): Promise<any> {
  try {
    const response = await api.get('/institutional/social-media');
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar as mídias sociais no footer', error);
    // throw new Error('Erro ao carregar a página');
  }
}

export async function getHomeBanners(): Promise<any> {
  try {
    const response = await api.get('/institutional/home-banners');
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar os banners da home', error);
    // throw new Error('Erro ao carregar a página');
  }
}

